import React from 'react';
import "./Logo.css";
import Flogo from "../../assets/logo.png";

const Logo = () => {
    return (
        <div className="ftop">
            <div className="logo">
                <a href='/'><img src={Flogo} alt="Fraudemail Logo" /></a>
            </div>
        </div>);
}

export default Logo;